import { useState } from 'react';
import { Button, Text } from '@chakra-ui/react';
import { useSearchParams } from 'react-router-dom';
import { googleProvider, signInWithProvider, facebookProvider } from '../../firebase';
import { BsFacebook } from 'react-icons/bs';
import { FcGoogle } from 'react-icons/fc';

function LoginWithProvider() {
    const [errorMessage, setErrorMessage] = useState('');
    const [searchParams] = useSearchParams();

    return (
        <div style={{ width: '100%' }}>
            <Button
                width="100%"
                marginBottom="2"
                size="lg"
                fontWeight="600"
                leftIcon={<FcGoogle />}
                onClick={() =>
                    signInWithProvider(
                        googleProvider,
                        setErrorMessage,
                        searchParams.get('profileId'),
                        searchParams.get('cid')
                    )
                }
            >
                Login with Google
            </Button>
            <Button
                width="100%"
                bg="facebook.500"
                color="white"
                size="lg"
                fontWeight="600"
                leftIcon={<BsFacebook />}
                _hover={{
                    background: 'facebook.800'
                }}
                onClick={() =>
                    signInWithProvider(
                        facebookProvider,
                        setErrorMessage,
                        searchParams.get('profileId'),
                        searchParams.get('cid')
                    )
                }
            >
                Login with Facebook
            </Button>
            <Text color="red">{errorMessage}</Text>
        </div>
    );
}

export default LoginWithProvider;
